import { BaseQueryFn } from '@reduxjs/toolkit/query';

export const rewriteLanguage = (args: BaseFundQueryArgs) => {
  const { site, language } = args.body || {};
  let updatedPayload = { ...args };

  if (
    site === 'Intermediary' &&
    language?.toLowerCase() === 'en-us' &&
    (args.url.includes('funds') || args.url.includes('library'))
  ) {
    updatedPayload = {
      ...args,
      body: {
        ...args.body,
        language: 'en-lu',
      },
    };
  }

  if (language?.toLowerCase() === 'en-nz') {
    updatedPayload = {
      ...args,
      body: {
        ...args.body,
        language: 'en-au',
      },
    };
  }

  return updatedPayload;
};

type BaseFundQueryArgs = {
  url: string;
  body: {
    site: string;
    language: string;
    [key: string]: string;
  };
};

export const withLanguageRewrite: (wrapped: BaseQueryFn) => BaseQueryFn<BaseFundQueryArgs> = (
  wrappedQuery: BaseQueryFn
): BaseQueryFn => {
  const newBaseQuery: BaseQueryFn<BaseFundQueryArgs> = (args, api, extraOptions) => {
    const updatedArgs = rewriteLanguage(args);
    return wrappedQuery(updatedArgs, api, extraOptions);
  };
  return newBaseQuery;
};
